/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */


interface InterpreterSearchRequest {
  country: string;
  city: string;
  /** Pulled from the LanguageLookup table */
  languageCode: string;
  service: string;
  gender: string;
}
const InterpreterSearchRequest = {
  create: (initValues?: Partial<InterpreterSearchRequest> | null): InterpreterSearchRequest => {
    const defaults: InterpreterSearchRequest = {
      country: "",
      city: "",
      languageCode: "",
      service: "",
      gender: "",
    };
    const fixedValues: Partial<InterpreterSearchRequest> = initValues != null
      ? {
      }
      : {};
    return { ...defaults, ...initValues, ...fixedValues };
  }
};

export default InterpreterSearchRequest;
